/**
 * StepTypeIcon - Maps step_type to a Heroicon
 */

import React from "react";
import {
  EnvelopeIcon,
  DevicePhoneMobileIcon,
  TagIcon,
  XMarkIcon,
  ClockIcon,
  UserGroupIcon,
  UserMinusIcon,
  PencilSquareIcon,
  ClipboardDocumentListIcon,
} from "@heroicons/react/24/outline";
import type { StepType } from "../../types/sequence.types";

interface StepTypeIconProps {
  stepType: StepType;
  className?: string;
}

const ICON_MAP: Record<StepType, React.FC<React.SVGProps<SVGSVGElement>>> = {
  send_email: EnvelopeIcon,
  send_sms: DevicePhoneMobileIcon,
  apply_tag: TagIcon,
  remove_tag: XMarkIcon,
  wait: ClockIcon,
  add_to_list: UserGroupIcon,
  remove_from_list: UserMinusIcon,
  update_attribute: PencilSquareIcon,
  create_task: ClipboardDocumentListIcon,
};

const StepTypeIcon: React.FC<StepTypeIconProps> = ({
  stepType,
  className = "h-5 w-5",
}) => {
  const Icon = ICON_MAP[stepType] || ClockIcon;
  return <Icon className={className} />;
};

export default StepTypeIcon;
